module.exports = __webpack_public_path__ + "static/assets/d7128d97f0b509645a1627d3ebf44bfc.svg";